import { lazyLoad } from 'app/utils/loadable';

export const News = lazyLoad(
  () => import('./news'),
  (module) => module.News
);
